// Here we create a template name to be shown in Google Analytics. If it is a standard template only the last part after - is shown
// Otherwise the publisher is shown and afterwards the last part of the name after - is added.
function createGoogleAnalyticsTemplateName(templateName) {
  const splitTemplateName = templateName.split("-");
  const shortName = [];

  if (splitTemplateName[0].toString().toLowerCase().trim() === "standard") {
    return splitTemplateName[splitTemplateName.length - 1].toString().trim();
  } else {
    shortName.push(splitTemplateName[0]);
    shortName.push(splitTemplateName[splitTemplateName.length - 1]);
  }

  return shortName.join("-");
}

export default createGoogleAnalyticsTemplateName;
